export default class SingleProduct {
    static initial() {
        this.ratingSelect();
        this.fixedNavMenu();
        this.countDownTimer();
        this.reviewsActions();
        this.plugins();
    }

    /**
     * Set rating on review form
     */
    static ratingSelect() {
        let $rating = $('.rating_can_select');

        $rating.find('.review_star li').hover(function () {
            let $this = $(this);
            $this.closest('.review_star').find('i').removeClass('icon-star');
            $this.closest('.review_star').find('i').addClass('icon-star-border');
            $this.closest('.review_star').find('li').each(function (index) {
                $(this).find('i').removeClass('icon-star-border');
                if($this.index() !== index) {
                    $(this).find('i').addClass('icon-star');
                } else {
                    $(this).find('i').addClass('icon-star');
                    return false;
                }
            });
        });

        $rating.on('mouseleave', function () {
            $(this).find('i').removeClass('icon-star').addClass('icon-star-border');
            $(this).find('i.fix').addClass('icon-star').removeClass('icon-star-border');
        });

        $rating.find('.review_star li').on('click', function () {
            let $this = $(this);
            $this.closest('.review_star').find('i').removeClass('fix icon-star').addClass('icon-star-border');
            $this.closest('.review_star').find('li').each(function (index) {
                if($this.index() !== index) {
                    $(this).find('i').removeClass('icon-star-border').addClass('fix icon-star');
                } else {
                    $(this).find('i').removeClass('icon-star-border').addClass('fix icon-star');
                    return false;
                }
            });

            $this.closest('.rating_can_select').find('input[name="rating"]').val($this.attr('data-r'));
        });
    }

    /**
     * Fixed nav menu & right product
     * >= 1200px
     */
    static fixedNavMenu() {
        if($(window).width() >= 1200) {
            let $menuProduct = $('.single_product_content');

            //Set width before fixed elements
            $menuProduct.find('.right .item_product_first').css('width', $menuProduct.find('.right .item_product_first').width());

            let rightProductH = $menuProduct.find('.right .item_product_first').height() + 20;
            $(window).bind('scroll.product.menu', function() {
                let scrollTop = $(window).scrollTop();

                if(scrollTop >= ($menuProduct[0].offsetTop - 20)) {
                    if(!$menuProduct.find('.right .item_product_first').hasClass('fixed')) {
                        $menuProduct.find('.right .item_product_first').addClass('fixed');
                    }
                    if($menuProduct.find('.right .item_product_first').hasClass('fixed')) {
                        let topPosition = (scrollTop - $menuProduct[0].offsetTop);
                        if(topPosition >= ($menuProduct.height() - rightProductH)) {
                            $menuProduct.find('.right .item_product_first').css({
                                'position': 'absolute',
                                'top': $menuProduct.height() - rightProductH
                            });
                        } else {
                            $menuProduct.find('.right .item_product_first').css({
                                'position': 'fixed',
                                'top': '20px'
                            });
                        }
                    }
                } else {
                    if($menuProduct.find('.right .item_product_first').hasClass('fixed')) {
                        $menuProduct.find('.right .item_product_first').removeClass('fixed');
                        $menuProduct.find('.right .item_product_first').css({
                            'position': 'relative',
                            'top': 'initial'
                        });
                    }
                }
            });
        }
    }


    /**
     * Count Down Timer
     * @data-date - time in milliseconds example '1609853845000'
     */
    static countDownTimer() {
        let $timers = $('.timer_count_down');
        $timers.each(function () {
            if($(this).attr('data-date')) {
                let $this = $(this),
                    timeDown = $(this).attr('data-date'),
                    timer = setInterval(function() {
                        // Get today's date and time
                        let now = new Date().getTime();

                        // Find the distance between now and the count down date
                        let distance = timeDown - now;
                        if(distance < 0) {
                            clearInterval(timer);
                            return false;
                        }

                        // Time calculations for days, hours, minutes and seconds
                        let days = Math.floor(distance / (1000 * 60 * 60 * 24)),
                            hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                            minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                            seconds = Math.floor((distance % (1000 * 60)) / 1000);

                        // Set double zero to number
                        days = (days > 9) ? days : '0' + days;
                        hours = (hours > 9) ? hours : '0' + hours;
                        minutes = (minutes > 9) ? minutes : '0' + minutes;
                        seconds = (seconds > 9) ? seconds : '0' + seconds;

                        // Display the result in the element with
                        $this.find('.days strong').html(days);
                        $this.find('.hours strong').html(hours);
                        $this.find('.minutes strong').html(minutes);
                        $this.find('.seconds strong').html(seconds);

                        //Set zero class
                        $this.find(' > span').removeClass('zero');
                        if(days === '00') {
                            $this.find('.days').addClass('zero');
                        }
                        if(hours === '00') {
                            $this.find('.hours').addClass('zero');
                        }
                        if(minutes === '00') {
                            $this.find('.minutes').addClass('zero');
                        }

                        // If the count down is finished, write some text
                        if (distance < 0) {
                            clearInterval(timer);
                        }

                    }, 1000);

                console.log(timeDown);
            }
        });
    }

    /**
     * Action on reviews zone
     */
    static reviewsActions() {
        //Replay action
        let $replay = $('.reviews_area--replay');
        if($replay.length) {

            //Toogle open
            $replay.find('.btn-replay').on('click', function (e) {
                e.preventDefault();
                $(this).siblings('form').slideToggle(200);
            });

            //Hide
            $replay.find('form .alpha-orange').on('click', function (e) {
                e.preventDefault();
                $(this).closest('form').slideUp(200);
            });

            //replay from
            $replay.find('form').each(function () {
                let $thisF = $(this).validate({
                    highlight: function (element) {
                        $(element).parent().addClass("error").removeClass("valid");
                    },
                    unhighlight: function (element) {
                        $(element).parent().removeClass("error").addClass("valid");
                    },
                    submitHandler: function (form) {
                        //Check actions
                        let action = $(form).attr('action'),
                            formData = new FormData($(form)[0]);

                        $(form).find('button[type="submit"]').prop('disabled', true);

                        $.ajax({
                            type: "POST",
                            url: action,
                            processData: false,
                            contentType: false,
                            data: formData
                        }).done(function (data) {
                            $(form).find('button[type="submit"]').prop('disabled', false);

                            $(form)[0].reset();
                            $thisF.resetForm();
                            $(form).find('.full').removeClass('full');

                            $(form).find('.form_component').fadeOut(200, function () {
                                $(form).find('.thanks').fadeIn(200);
                                setTimeout(function () {
                                    $(form).slideUp(200, function () {
                                        $(form).find('.form_component').show();
                                        $(form).find('.thanks').hide();
                                    });
                                }, 2000)
                            });
                        });
                    }
                });
            });
        }

        //First review
        let $reviewEmpty = $('.reviews_area.empty');
        if($reviewEmpty.length) {
            let $emptyF = $reviewEmpty.find('form').validate({
                highlight: function (element) {
                    $(element).parent().addClass("error").removeClass("valid");
                },
                unhighlight: function (element) {
                    $(element).parent().removeClass("error").addClass("valid");
                },
                submitHandler: function (form) {
                    //Check actions
                    let action = $(form).attr('action'),
                        formData = new FormData($(form)[0]);

                    $(form).find('button[type="submit"]').prop('disabled', true);
                    $.ajax({
                        type: "POST",
                        url: action,
                        processData: false,
                        contentType: false,
                        data: formData
                    }).done(function (res) {
                        console.log(res); //TODO: debug

                        if(res.success) {
                            $(form).fadeOut(200, function () {
                                $(form).siblings('.thanks').fadeIn(200);
                                $(form).find('button[type="submit"]').prop('disabled', false);

                                //Clear
                                $(form)[0].reset();
                                $emptyF.resetForm();
                                $(form).find('.full:not([name="date_from"]):not([name="date_to"])').each(function () {
                                    if($(this).val() === '') {
                                        $(this).removeClass('full');
                                    }
                                });
                            });
                             return true;
                        }
                        alert('Упс.');
                    });
                }
            });
        }

        //Load more
        let $loadMoreReview = $('#load-more-review');
        if($loadMoreReview.length) {
            $loadMoreReview.on('click', function () {
                let self = $(this),
                    max = Number(self.attr('data-max')),
                    formData = new FormData();

                self.prop('disabled', true);
                formData.append('offset', self.attr('data-offer'));
                formData.append('product_id', self.attr('data-product-id'));

                $.ajax({
                    type: "POST",
                    url: self.attr('data-url'),
                    processData: false,
                    contentType: false,
                    data: formData
                }).done(function (res) {
                    self.prop('disabled', false);
                    if(res.success) {
                        self.parent().before(res.data.data);
                        if(res.data.offers >= max) {
                            self.parent().remove();
                        } else {
                            self.attr('data-offer', res.data.offers);
                        }
                        return true;
                    }
                    alert('Ooops. Some Error.');
                });
            })
        }
    }

    /**
     * Initial plugins for this page
     */
    static plugins() {

        //Images carousel
        let $imagesCarousel = $('.single_product_images:not(.no-init)');
        if($imagesCarousel.length) {

            let $carouselMenu = $('.single_product_navigate');
            $imagesCarousel.on('changed.owl.carousel', function(event){
                let currentItem = event.item.index;
                $carouselMenu.find('.active').removeClass('active');
                $carouselMenu.find('a:nth-child(' + (currentItem + 1) + ')').addClass('active');
            });

            $imagesCarousel.owlCarousel({
                loop: false,
                margin: 0,
                items:1,
                dots: true,
                nav: false,
                responsive:{
                    1200:{
                        nav: false,
                        dots: false,
                        URLhashListener:true,
                        startPosition: 'URLHash'
                    }
                },
                afterInit: function(elem){
                    console.log(elem);
                }
            });
        }

        //Video carousel
        let $videosCarousel = $('.video_carousel');
        if($videosCarousel.length) {

            //TODO: stop video after change slide

            //Set active navigate
            let $videoCarouselMenu = $('.video_carousel_nav');
            $videosCarousel.on('changed.owl.carousel', function(event){
                let currentItem = event.item.index;
                $videoCarouselMenu.find('.active').removeClass('active');
                $videoCarouselMenu.find('a:nth-child(' + (currentItem + 1) + ')').addClass('active');
            });

            $videosCarousel.owlCarousel({
                items:1,
                loop:false,
                margin: 0,
                video:true,
                lazyLoad:true,
                center:true,
                dots: false,
                nav: false,
                URLhashListener:true,
                startPosition: 'URLHash'
            })
        }

        //Validate only over input for popup #report_availability
        let $avilable = $('#report_availability');
        $avilable.find('input').on('keyup blur', function () {
            $(this).closest('form').find('input').attr('required');
            if($(this).val() !== '') {
                $(this).closest('form').find('input').not($(this)).removeAttr('required');
            }
        });

    }
}
